import { Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  AJOUTER_QUARTIER_COMMUNE,
  DELETE_BATIMENT,
  QUARTIER_COMMUNE,
} from "../../Utils/constant";
import { Home } from "../../components/Icons/Home";
import { UpdateTypeBatimentForm } from "../../components/TypeBatiment/UpdateTypeBatimentForm";
import { Loader } from "../../components/Widget/Loader";
import { deleteOne, store } from "../../services/service";
import { useStoreCommune } from "../../store/storeCommune";

export const Quartier = ({ id }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const quartiers = useStoreCommune();
  const [itemUpdate, setItemUpdate] = useState(false);

  useEffect(() => {
    quartiers.getQuartier(
      `${QUARTIER_COMMUNE}?communeId=${id}&page=0&param=&size=10`
    );
  }, []);

  const more = (page) => {
    quartiers.getQuartier(
      `${QUARTIER_COMMUNE}?communeId=${id}&page=${page - 1}&param=&size=10`
    );
  };

  const submit = (data) => {
    setIsSubmit(true);
    store(
      `${AJOUTER_QUARTIER_COMMUNE}/${id}?designation=${data.designation}`,
      "application/json",
      {}
    )
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          quartiers.getQuartier(
            `${QUARTIER_COMMUNE}?communeId=${id}&page=0&param=&size=10`
          );
          document.getElementById("fermer_create_trajet").click();
          toast.success("Quariter ajouté ");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  return (
    <>
      <div>
        <div className="mt-4 lg:flex item-center ">
          {/* <h1 className="text-2xl font-extrabold text-black">Type d'équipements</h1> */}
          <input
            type="text"
            placeholder="Rechercher element..."
            className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
          />
          <div className="ml-auto">
            <button
              button
              onClick={() => document.getElementById("quartier").showModal()}
              className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
            >
              Ajouter un quartier
            </button>
            {/* {checkTagValidity("AJOUTER_BATIMENT") ? (
              <button
                button
                onClick={() =>
                  document.getElementById("quartier").showModal()
                }
                className="btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white"
              >
                Ajouter un type de batiment
              </button>
            ) : null} */}
            <dialog id="quartier" className="modal ">
              <div className="modal-box ">
                <div className="modal-action">
                  <h1 className="mr-auto text-2xl font-bold">
                    Ajouter un quartier
                  </h1>
                  <form method="dialog">
                    <button
                      id="fermer_create_trajet"
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                    >
                      ✕
                    </button>
                  </form>
                </div>
                <form onSubmit={handleSubmit(submit)} className="px-2">
                  <div className="my-4 space-y-4">
                    <div className="my-2">
                      <label htmlFor="" className="text-sm font-medium">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder=""
                        className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        {...register("designation", { required: true })}
                      />
                      {errors.designation && (
                        <span className="text-sm text-rose-600">
                          Ce champs est obligatoire
                        </span>
                      )}
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmit ? true : false}
                      className={`${
                        !isSubmit
                          ? "text-black bg-main"
                          : "text-slate-800 bg-slate-200 "
                      } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                      {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                      {isSubmit ? (
                        <span className="loading loading-dots loading-xs"></span>
                      ) : null}
                    </button>
                  </div>
                </form>
              </div>
            </dialog>
          </div>
        </div>
        <dialog id="updateBat" className="modal">
          <div className="modal-box ">
            <div className="modal-action">
              <h1 className="mr-auto text-2xl font-bold">
                Modification d'un type de batiment
              </h1>
              <form method="dialog">
                <button
                  id="fermer_create_trajet"
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                >
                  ✕
                </button>
              </form>
            </div>
            <UpdateTypeBatimentForm item={itemUpdate} />
          </div>
        </dialog>
        <div className="grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 gap-2 my-8">
          {quartiers?.quartier?.data?.length === 0 ? (
            "Aucune donnée"
          ) : quartiers?.quartier?.data?.length !== 0 && !quartiers?.loading ? (
            quartiers?.quartier?.data?.map((item) => (
              <div className="relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs text-center">
                {/* <div className="dropdown dropdown-end absolute right-2 top-2">
                  <div
                    tabIndex={0}
                    role="button"
                    className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                  >
                    <MoreHorizontal size={20} />
                  </div>
                  <ul
                    tabIndex={0}
                    className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                  >
                    <button
                      className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                      onClick={() => {
                        // document.getElementById("updateBat").showModal();
                        setItemUpdate(item);
                      }}
                    >
                      Modifier
                    </button>
                    
                    <button
                      onClick={() => {
                        setItemUpdate(item);
                        document.getElementById("delete").showModal();
                      }}
                      className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                    >
                      Supprimer
                    </button>
                  </ul>
                </div> */}
                <div className="bg-gray-100 w-10 h-10 rounded m-1 flex items-center justify-center">
                  <Home />
                </div>
                <div>
                  <p className="truncate w-28">{item.designation}</p>
                </div>
              </div>
            ))
          ) : (
            <Loader />
          )}
        </div>
        <div className="my-3 flex justify-end">
          <Pagination
            onChange={(event, newValue) => more(newValue)}
            onSelect={(selectedPage) => more(selectedPage)}
            count={quartiers?.quartier?.totalPages}
            variant="outlined"
            color="primary"
            shape="rounded"
          />
        </div>
        <dialog id="delete" className="modal">
          <div className="modal-box max-w-md rounded-lg">
            <h3 className="font-extrabold text-xl text-red-600 ">Attention</h3>
            <p className="pt-2 text-black font-medium">
              Voulez vous vraiment effectuer cette action ?
            </p>
            <div className="modal-action">
              <form
                method="dialog"
                className="w-full flex items-center justify-end gap-x-4"
              >
                <button className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                  Annuler
                </button>
                <button
                  onClick={() => {
                    deleteOne(DELETE_BATIMENT, itemUpdate.id)
                      .then(() => {
                        quartiers.batiments({ page: 0, param: "", size: 10 });
                        toast.success(
                          `${itemUpdate.designation + " supprimé"}`
                        );
                      })
                      .catch((err) => {});
                  }}
                  className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold"
                >
                  Supprimer
                </button>
              </form>
            </div>
          </div>
        </dialog>
      </div>
    </>
  );
};
